import { useContext } from 'react';
import {
  AlertNotificationsContext,
  AlertNotificationsLiveContext,
  AlertNotificationsStableContext,
  type AlertNotificationsContextValue,
  type AlertNotificationsLiveSlice,
  type AlertNotificationsStableSlice,
} from './alert-notifications/context';

export function useAlertNotifications(): AlertNotificationsContextValue {
  const ctx = useContext(AlertNotificationsContext);
  if (!ctx) {
    throw new Error('useAlertNotifications must be used inside <AlertNotificationsProvider>');
  }
  return ctx;
}

/** Subscribe ONLY to the live slice (recent/unreadCount/toasts).
 *  Identity changes ~10 Hz while alerts tick. Use this from
 *  `AlertBell`, `ToastStack`, and other bell consumers. */
export function useAlertNotificationsLive(): AlertNotificationsLiveSlice {
  const ctx = useContext(AlertNotificationsLiveContext);
  if (!ctx) {
    throw new Error('useAlertNotificationsLive must be used inside <AlertNotificationsProvider>');
  }
  return ctx;
}

/** Subscribe ONLY to the stable slice (callbacks + muted + readSet
 *  + persistenceAvailable). Identity is stable across alerts-cache
 *  ticks. Use this from consumers like `TopBar` that only need the
 *  master-mute toggle. */
export function useAlertNotificationsStable(): AlertNotificationsStableSlice {
  const ctx = useContext(AlertNotificationsStableContext);
  if (!ctx) {
    throw new Error('useAlertNotificationsStable must be used inside <AlertNotificationsProvider>');
  }
  return ctx;
}